import { Hypervisor, HypervisorType } from '../enums';

export type ProvisioningJobStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';

export type ProvisioningStep = 'PREPARING' | 'CUSTOMIZING' | 'CONVERTING' | 'PACKAGING' | 'COMPLETED' | 'FAILED';

export interface ProvisioningJobCreateRequest {
  hypervisor: Hypervisor;
  name?: string;
}

export interface ProvisioningJobResponse {
  jobId: string;
  customerId: number;
  hypervisor: Hypervisor;
  name?: string | null;
  status: ProvisioningJobStatus;
  currentStep: ProvisioningStep;
  progressPercentage: number;
  estimatedRemainingSeconds: number;
  downloadUrl?: string | null;
  error?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export function getProvisioningStepTranslationKey(step: ProvisioningStep, hypervisor?: Hypervisor): string {
  if (step === 'CONVERTING') {
    switch (hypervisor) {
      case 'HYPERV':
        return 'provisioning.steps.CONVERTING.HYPERV';
      case 'VMWARE':
        return 'provisioning.steps.CONVERTING.VMWARE';
      case 'VIRTUALBOX':
        return 'provisioning.steps.CONVERTING.VIRTUALBOX';
      default:
        return 'provisioning.steps.CONVERTING.DEFAULT';
    }
  }

  if (step === 'PACKAGING') {
    if (hypervisor === 'VIRTUALBOX') {
      return 'provisioning.steps.PACKAGING.VIRTUALBOX';
    }
    return 'provisioning.steps.PACKAGING.DEFAULT';
  }

  return `provisioning.steps.${step}`;
}

export const DEFAULT_PROVISIONING_ESTIMATE_SECONDS = 30;

export interface VmProvisionRequest {
  hypervisor: HypervisorType | Hypervisor;
  name?: string;
  customerId?: string | number | null;
}

export type VmProvisionStatus = 'idle' | 'provisioning' | 'downloading' | 'completed' | 'error';

export interface VmProvisionDownloadState {
  status: VmProvisionStatus;
  jobId?: string;
  currentStep?: ProvisioningStep;
  hypervisor?: Hypervisor;
  stepLabel?: string;
  progress: number;
  downloadedBytes: number;
  totalBytes: number;
  totalBytesKnown: boolean;
  speedBytesPerSec: number;
  timeRemainingSeconds: number | null;
  estimatedRemainingSeconds: number | null;
  elapsedSeconds: number;
  downloadUrl?: string;
  checksum?: string | null;
  fileName?: string;
  blob?: Blob;
  blobUrl?: string;
  error?: string;
  logs?: string[];
}
